// extracted by mini-css-extract-plugin
module.exports = {"overviewSVG":"Overview_overviewSVG__1jo7i"};